<template>
    <div>
      <div class="flex items-center justify-between" style="height: 40px">
        <div class="h-full flex items-center">
          <el-dropdown hidden>
            <button
              class="sort-button flex items-center justify-center rounded-md h-full mr-3"
              :class="{ 'shadow-sm': sortList }"
              style="width: 40px; height: 40px; background-color: #f7fafd"
            >
              <sort-icon />
            </button>
            <el-dropdown-menu slot="dropdown" placement="right-end">
              <el-dropdown-item disabled>SORT BY</el-dropdown-item>
  
              <el-dropdown-item>
                <button @click="sortOrder = 'ASC'" class="flex items-center">
                  <span class="ml-2">ASC</span>
                </button>
              </el-dropdown-item>
              <el-dropdown-item>
                <button @click="sortOrder = 'DESC'" class="flex items-center">
                  <span class="ml-2">DESC</span>
                </button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
  
          <div class="flex items-center mr-8">
            <div class="table__search-input-wrapper">
              <span class="pr-2">
                <search-icon />
              </span>
  
              <input
                type="text"
                class="table__search-input"
                placeholder="Search..."
                v-model="queryString"
              />
  
              <search-drop-down-icon />
            </div>
          </div>
        </div>
  
        <div class="date-picker flex items-center justify-center">
          <el-date-picker
            type="date"
            placeholder="Start Date"
            style="margin: 0"
            class="mr-3"
            v-model="startDate"
          />
  
          <el-date-picker
            type="date"
            placeholder="End Date"
            style="margin: 0"
            v-model="endDate"
          />
        </div>
      </div>
  
      <div
        class="mt-5 table-header flex flex-nowrap bg-[#E5E5E5] text-md justify-around p-4 pl-11 border-y-1 border-[#D9D5EC] overflow-wrap text-[#383F51]"
      >
        <p class="w-1/12"><input type="checkbox" class="checkbox mt-1" /></p>
        <p class="w-4/12 ml-2">Shipping Id #</p>
        <p class="w-4/12 ml-2" v-if="currentTab == 'handsoff'">Forwarding 3pl</p>
        <p class="w-4/12 ml-2">Dispatcher</p>
        <p class="w-4/12 ml-2" v-if="currentTab == 'return' || currentTab == 'fulfillment'">Customer <br>(shipper)</p>
        <p class="w-4/12 ml-2">Receiver</p>
        <p class="w-4/12 ml-2" v-if="currentTab == 'handsoff'">Conditions of Goods</p>
        <p class="w-4/12 ml-2" v-if="currentTab == 'return'">Reason for <br /> Return</p>
        <p class="w-4/12 ml-2" v-if="currentTab == 'return'">Return Date</p>
        <p class="w-4/12 ml-2" v-if="currentTab == 'handsoff'">Delivery Status</p>
        <p
          class="w-4/12 ml-2"
          v-if="currentTab == 'return'"
        >
          Status
        </p>
        <p
          class="w-4/12 ml-2"
          v-if="currentTab == 'fulfillment'"
        >
          Delivery States
        </p>
        <p class="w-4/12 ml-2" v-if="currentTab == 'handsoff'">Handoff Date</p>
        <p class="w-4/12 ml-2" v-if="currentTab == 'fulfillment'">Delivery Date</p>
        <div
          class="w-1/12 overflow-x-auto text-xs text-right"
        >
          <img
            src="../../../../assets/images/icons/options-icon.png"
            class="inline-block"
          />
        </div>
      </div>
  
      <div v-if="userequest.length > 0">
        <TablerowBase
          class="mt-3"
          v-for="request in userequest"
          :key="request.id"
          @refetch-requests="getAllRequest()"
          :request="request"
          :currentTab="currentTab"
        />
      </div>
      <div v-else>
        <div
          class="flex flex-col items-center gap-2 justify-center p-5 bg-white w-100"
        >
          <empty-booking-icon />
          <p>No Requests Currently</p>
        </div>
      </div>
  
      <pagination-control @paginate-pagesize-changed="perPageSize" class="mt-3" />
    </div>
  </template>
  
  <script>
  import PaginationControl from "@/components/UI/NewPagination";
  
  import TablerowBase from "./BookingTablerowBase";
  import moment from "moment";
  
  export default {
    props: ["currentTab"],
    components: {
      PaginationControl,
      TablerowBase,
    },
    data() {
      return {
        selectedFleetId: null,
        fleets: [],
        removedTableData: [],
        isLoading: false,
        isTableFilter: false,
        showHoldModal: false,
        date: 0,
        location: "null",
        queryString: "",
        sortList: false,
        startDate: "",
        endDate: "",
        shippingServices: [],
        dispatches: [],
        requests: [],
        loadingDispatches: true,
        sortOrder: "ASC",
        pageSize: 10,
        sortColumn: "",
      };
    },
    computed: {
      checkCurrentTab() {
        let val = "";
        switch (this.currentTab) {
          case "handsoff":
            val = "handoff";
            break;
  
          case "fulfillment":
            val = "fulfillment";
            break;
        }
        return val;
      },
      userequest() {
        return this.requests.filter(
          (x) => x.event == `process:${this.checkCurrentTab}`
        );
      },
    },
    watch: {
      currentTab() {
        this.getAllRequest({});
      },
      queryString() {
        if (this.startDate && this.endDate) {
          this.getAllRequest({
            startDate: moment(this.startDate).format("YYYY-MM-DD"),
            endDate: moment(this.endDate).format("YYYY-MM-DD"),
          });
        } else {
          this.getAllRequest({});
        }
      },
      // sortColumn() {
      //     this.getDispatches({
      //         dispatchType: this.currentTab,
      //         sortOrder: this.sortOrder,
      //         startDate: this.startDate != null ?
      //             moment(this.startDate).format("YYYY-MM-DD") :
      //             "",
      //         endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
      //         searchTerm: this.query,
      //         pageSize: this.pageSize,
      //         sortColumn: this.sortColumn,
      //     });
      // },
      // pageSize() {
      //     this.getDispatches({
      //         dispatchType: this.currentTab,
      //         sortOrder: this.sortOrder,
      //         startDate: this.startDate != null ?
      //             moment(this.startDate).format("YYYY-MM-DD") :
      //             "",
      //         endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
      //         searchTerm: this.query,
      //         pageSize: this.pageSize,
      //         sortColumn: this.sortColumn,
      //     });
      // },
      startDate() {
        if (this.startDate && this.endDate) {
          this.getAllRequest({
            startDate: moment(this.startDate).format("YYYY-MM-DD"),
            endDate: moment(this.endDate).format("YYYY-MM-DD"),
          });
        }
      },
  
      endDate() {
        if (this.startDate && this.endDate) {
          this.getAllRequest({
            startDate: moment(this.startDate).format("YYYY-MM-DD"),
            endDate: moment(this.endDate).format("YYYY-MM-DD"),
          });
        }
      },
    },
    mounted() {
      this.getAllRequest({});
    },
  
    methods: {
      async getAllRequest(filters) {
        try {
          let payload = {};
  
          if (this.checkCurrentTab == "fulfillment") {
            if (this.queryString.length > 0) {
              payload = {
                ...filters,
                event: `process:${this.checkCurrentTab}`,
                message: {
                  module: "shippings",
                  orgId: this.$store.state.authentication.organizationId,
                  booking: {
                    shippingId: this.queryString,
                  },
                },
              };
            } else {
              payload = {
                ...filters,
                event: `process:${this.checkCurrentTab}`,
                message: {
                  module: "shippings",
                  orgId: this.$store.state.authentication.organizationId,
                },
              };
            }
          } else if (this.checkCurrentTab == "handoff") {
            if (this.queryString.length > 0) {
              payload = {
                ...filters,
                event: `process:${this.checkCurrentTab}`,
                message: {
                  module: "dispatch",
                  destination: {
                    orgId: this.$store.state.authentication.organizationId,
                  },
                  booking: {
                    shippingId: this.queryString,
                  },
                },
              };
            } else {
              payload = {
                ...filters,
                event: `process:${this.checkCurrentTab}`,
                message: {
                  module: "dispatch",
                  destination: {
                    orgId: this.$store.state.authentication.organizationId,
                  },
                },
              };
            }
          }
  
          const response = await this.$_getRequest(payload);
          console.log(response.data.messages);
          this.requests = response.data.messages;
        } catch (error) {
          this.handleError(error);
        }
      },
  
      perPageSize(pageSize) {
        this.pageSize = pageSize;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  th {
    color: #707684;
  }
  
  td {
    background: #ffffff;
    color: var(--primaryblue);
    font-weight: 500;
    border-radius: 2px;
    padding: 1rem 0.75rem;
    vertical-align: top;
    font-size: 0.9rem;
  
    span {
      display: block;
    }
  
    span:last-of-type {
      font-weight: normal;
      color: #10233e;
      opacity: 0.6;
      padding-top: 0.25rem;
      font-size: 0.8rem;
    }
  }
  
  .table-header {
    border-bottom: 1px solid #e1e3ea;
  
    p {
      color: #383f51;
      opacity: 0.5;
    }
  }
  
  .table__search-input-wrapper {
    background: #f7fafd;
    width: 20rem;
    border-radius: 5px;
    border: 1px solid #dae8f6;
    border-radius: 5px;
    height: 40px;
  }
  
  .checkbox {
    display: initial;
    width: 1rem;
    height: 1rem;
  }
  
  table {
    border-collapse: separate;
    border-spacing: 0 0.5rem;
  }
  
  .actions {
    position: absolute;
    background: #ffffff;
    top: 3rem;
    right: 2rem;
    padding: 0.75rem;
    z-index: 999;
    font-size: 0.9rem;
    width: 10rem;
  
    background: #ffffff;
    /* Stroke */
  
    border: 1px solid #e7e7e9;
    box-sizing: border-box;
    box-shadow: 0px 20px 80px #dbd9d9;
    border-radius: 10px;
  
    span {
      padding-right: 0.25rem;
    }
  
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 0.5rem;
    }
  }
  </style>
  